import React, { useEffect, useState } from 'react'
import { Box, Flex, Heading, Text, Link } from 'rebass/styled-components'
import styled from 'styled-components'
import renderHTML from 'react-render-html'
import AnimationWrapper from '../helpers/Animations'
import MediaRender from '../components/general/MediaRender'

const NarrativeContent = styled(Box)`
    border-color: ${(props) => props.theme.colors.black};
    border-style: solid;
    border-width: 0 0 0 1px;
    padding-bottom: ${(props) => props.theme.space.xxs};

    span {
        display: block;
    }

    a {
        color: ${(props) => props.theme.colors.black};
        cursor: pointer;
        display: inline-block;
        font-family: ${(props) => props.theme.fonts.body};
        font-size: ${(props) => props.theme.fontSizes.md};
        font-weight: ${(props) => props.theme.fontWeights.semibold};
        text-decoration: none;
        overflow: hidden;
        padding: 0 0 5px 0;
        position: relative;
        &::before,
        &::after {
            background-color: ${(props) => props.theme.colors.black};
            content: '';
            display: inline-block;
            height: 2px;
            left: 0;
            opacity: 1;
            position: absolute;
            bottom: 0;
            width: 100%;
            z-index: -1;
        }
        &::before {
            background-color: ${(props) => props.theme.colors.aquaDark};
            z-index: 0;
            transform: translateX(-100%);
            transition-duration: 350ms;
            transition-timing-function: cubic-bezier(0.77, 0.0, 0.175, 1);
            transition-property: transform;
        }

        &:hover::before {
            transform: translateX(0);
        }
    }
`

const FeaturedPublication = ({ options }) => {
    const [media, updateMedia] = useState({ el: false })

    useEffect(() => {
        if (options.media.set && options.media.set.length) {
            const update = { ...media }
            update.el = <MediaRender file={options.media.set[0]} alt={options.title} />
            updateMedia(update)
        }
    }, [options])


    return (
        <Box
            variant="container"
            mb="xxl"
            mt="xl"
            pl={['xxs', 'sm', 'sm', 'sm', 'sm', '5%', '5%']}
            pr={['xxs', 'sm', 'sm', 'sm', 'sm', '5%', '5%']}
        >
            <AnimationWrapper type="fade-left">
                <Heading
                    as="h2"
                    color="aquaDark"
                    pl={['sm', 'sm', 'sm', '0']}
                    variant="h1"
                >
                    {options.heading}
                </Heading>
            </AnimationWrapper>

            <Flex
                alignContent="flex-start"
                alignItems="flex-start"
                flexDirection={['column', 'column', 'column', 'row']}
                mt={['xxs', 'xxs', 'xxs', 'xl']}
            >
                <Box
                    alignSelf={['flex-start', 'flex-start', 'flex-start', 'center']}
                    flexGrow="1"
                    mr={['0', '0', '0', 'sm', 'md', 'lg']}
                    mt={['md', 'md', 'md', '0']}
                    order={[1, 1, 1, 0]}
                    pr={['sm', 'sm', 'sm', '0']}
                    width={['100%', '100%', '100%', '50%']}
                >
                    <NarrativeContent
                        ml={['0', '0', '0', '0', '0', 'xxl', 'xxl']}
                        pl={['sm', 'sm', 'sm', 'sm', 'sm', 'sm', 'sm']}
                    >
                        <Heading
                            as="h3"
                            variant="h2"
                            sx={{
                                lineHeight: '30px',
                                paddingBottom: '0',
                                textTransform: 'uppercase',
                            }}
                        >{options.title}</Heading>

                        <Text as="span"
                            fontStyle="italic"
                            fontSize="md">
                            {options.subtitle}
                        </Text>
                        <Text
                            as="span"
                            color="aquaDark"
                            pt="md"
                            pb="lg"
                            variant="quote"
                            sx={{
                                lineHeight: '30px',
                            }}
                        >
                            {renderHTML(options.text)}
                        </Text>
                        {/* TODO: revert to link being dynamic, e.g. options.href */}
                        <Link target="_blank" href="https://miurabook.com/shop/the-lamborghini-miura-book-register-only/">View Publication</Link>
                    </NarrativeContent>
                </Box>
                <Box
                    alignSelf="flex-start"
                    flexGrow="1"
                    ml={['0', '0', '0', 'sm', 'md', 'lg']}
                    mt={['md', 'md', 'md', '0']}
                    order={[0, 0, 0, 1]}
                    width={['100%', '100%', '100%', '50%']}
                >
                    <Link target="_blank" href='https://miurabook.com/shop/the-lamborghini-miura-book-register-only/'>{media.el}</Link>
                </Box>
            </Flex>
        </Box>
    )
}

export default FeaturedPublication
